import newRequest from '@/utils/new-request';

// 资金台账列表
export const apiOfferPricePage = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/fund/ledger',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 导出
export const apiOfferPriceExport = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/fund/ledgerExport',
    data,
    isLoading: isBool // 是否显示加载中参数
  });
};

// 统计
export const apiOfferPriceStatistics = (data) => {
  return newRequest({
    method: 'post',
    url: '/fund/ledgerStatistics',
    data,
    isLoading: false // 是否显示加载中参数
  });
};

// 消息通知列表
export const apiFundNotice = (isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/customerWalletNoticeStrategy/list',
    isLoading: isBool // 是否显示加载中参数
  });
};

// 保存
export const apiFundNoticeSave = (data) => {
  return newRequest({
    method: 'POST',
    url: '/customerWalletNoticeStrategy/save',
    data,
    isLoading: true // 是否显示加载中参数
  });
};

// 删除
export const apiFundNoticeDelete = (id) => {
  return newRequest({
    method: 'POST',
    url: `/customerWalletNoticeStrategy/remove/${id}`,
    isLoading: false // 是否显示加载中参数
  });
};

// 资金充值明细
export const apiFundRechargeDetail = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/fund/rechargePage',
    data,
    isLoading: isBool
  });
};

// 导出
export const apiFundRechargeDetailExport = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/fund/rechargeDetailExport',
    data,
    isLoading: isBool
  });
};

// 人工充值单个
export const apiFundRecharge = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/fund/recharge',
    data,
    isLoading: isBool
  });
};

// 批量充值
export const apiFundRechargeBatch = (data) => {
  return newRequest({
    method: 'POST',
    url: '/fund/rechargeBatch',
    data,
    isLoading: true
  });
};

// 资金充值状态更新
export const apiFundRechargeDetailUpdate = (data) => {
  return newRequest({
    method: 'POST',
    url: `/fund/updateRechargeCheckStatus`,
    params: data,
    isLoading: true
  });
};

// 收款账号
export const apiFundAccountList = (isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/fund/accountPage',
    isLoading: isBool
  });
};

// CNPJ查询客户
export const apiFundAccountCnpj = (data) => {
  return newRequest({
    method: 'POST',
    url: '/rpc/prepaidCustomer/page1',
    data,
    isLoading: true
  });
};

// 资金发生明细列表
export const apiFundDetailList = (data, isBool = true) => {
  return newRequest({
    method: 'POST',
    url: '/customerOrderFundOccupy/getPage',
    data,
    isLoading: isBool
  });
};

// 修改资金状态
export const apiFundDetailUpdateStatus = (data) => {
  return newRequest({
    method: 'POST',
    url: '/customerOrderFundOccupy/editOrderFundStatus',
    data,
    isLoading: true
  });
};

// 批量修改资金状态
export const apiFundDetailUpdate = (data) => {
  return newRequest({
    method: 'POST',
    url: '/customerOrderFundOccupy/batchEditOrderFundStatus',
    data,
    isLoading: true
  });
};

// 资金明细导出
export const apiFundDetailExport = (data) => {
  return newRequest({
    method: 'POST',
    url: '/customerOrderFundOccupy/export',
    data,
    isLoading: true
  });
};
// 查询CNPJ
export const apiFundAccountPage1 = (data) => {
  return newRequest({
    method: 'POST',
    url: '/rpc/prepaidCustomer/page1',
    data,
    isLoading: true
  });
};
// 查询收款银行账号
export const apiFundAccountPage = (data) => {
  return newRequest({
    method: 'POST',
    url: '/fund/accountPage',
    data,
    isLoading: true
  });
};
// 客户信息查询
export const prepaidCustomerPage = (data) => {
  return newRequest({
    method: 'POST',
    url: '/rpc/prepaidCustomer/page',
    data,
    isLoading: true
  });
};
